import React from 'react';

// function step(timestamp) {
//     if (!start) start = timestamp;
//     var progress = timestamp - start;
//     element.style.left = Math.min(progress / 10, 200) + 'px';
//     if (progress < 2000) {
//         window.requestAnimationFrame(step);
//     }
// }
//
// window.requestAnimationFrame(step);
//
// https://codepen.io/depthdev/pen/wyDis
// https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
class Canvas extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        return <canvas id="canvas"></canvas>
    }
}

export default TopToBottom;
